import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";

/**
 * Floating back control for report sub-pages on large screens only.
 * Mobile navigation uses ReportMobileNav (Detaljer / home).
 */
export function ReportDesktopBackButton({ reportId, className }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!reportId) return null;

  return (
    <button
      type="button"
      className={clsx(
        "fixed bottom-6 z-40 hidden h-14 w-14 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-800 shadow-lg transition-[left,transform,background-color] duration-300 ease-in-out hover:bg-gray-50 active:scale-95 lg:flex",
        className
      )}
      style={{
        left: "calc(var(--dashboard-sidebar-width, 4rem) + 1.5rem)",
      }}
      onClick={() => navigate(`/dashboard/service/reports/${reportId}`)}
      aria-label={t("report.view.backToReport")}
    >
      <ArrowLeftIcon className="h-6 w-6 shrink-0" aria-hidden />
    </button>
  );
}

export default ReportDesktopBackButton;
